import { useEffect, useRef, useState } from "react";
import { clientCategories } from "../data/mock";

export const ClientsCarousel = () => {
  const scrollRef = useRef(null);
  const scrollPosRef = useRef(0); // ✅ persists value
  const animationRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const speed = 0.6;

    const animate = () => {
      if (!isPaused && container) {
        scrollPosRef.current += speed;

        if (scrollPosRef.current >= container.scrollWidth / 2) {
          scrollPosRef.current = 0;
        }

        container.scrollLeft = scrollPosRef.current;
      }

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationRef.current);
  }, [isPaused]);
  const duplicatedItems = [...clientCategories, ...clientCategories, ...clientCategories];

  return (
    <section id="clients" className="py-20 bg-[#f8fafc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <span className="text-[#ff9900] font-semibold text-sm uppercase tracking-wider">
            Our Clientele
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0a2a43] mt-3 mb-4">
            Serving Diverse Sectors
          </h2>
          <p className="text-[#4a6680] max-w-2xl mx-auto text-lg">
            From residential complexes to industrial plants, we deliver automation solutions across sectors.
          </p>
        </div>
      </div>

      <div
        ref={scrollRef}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        className="overflow-hidden cursor-pointer"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        <div className="flex gap-6 px-4 w-max">
          {duplicatedItems.map((item, index) => (
            <div
              key={`${item.id}-${index}`}
              className="flex-shrink-0 w-56 group"
            >
              <div className="bg-white rounded-2xl p-6 border border-[#e2e8f0] hover:border-[#ff9900]/30 hover:shadow-lg hover:shadow-[#ff9900]/5 transition-all duration-300 text-center">
                <div className="w-16 h-16 rounded-2xl bg-[#0a2a43]/5 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#ff9900]/10 transition-colors duration-300">
                  <item.Icon className="w-7 h-7 text-[#0a2a43] group-hover:text-[#ff9900] transition-colors duration-300" />
                </div>
                <h3 className="font-semibold text-[#0a2a43] text-sm">
                  {item.label}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
